// services/calendar.js
import axiosInstance from './axiosInstance';

const CALENDAR_API_URL = '/calendar';

const calendarService = {
  // Obter eventos do calendário por intervalo de datas
  async getByRange(idempresa, startTimestamp, endTimestamp) {
    try {
      const response = await axiosInstance.get(
        `${CALENDAR_API_URL}/getByRange.php?idempresa=${idempresa}&start=${startTimestamp}&end=${endTimestamp}`
      );
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter eventos do calendário:', error);
      return [];
    }
  },

  // Obter aniversários por intervalo de datas
  async getBirthdaysByRange(idempresa, startTimestamp, endTimestamp) {
    try {
      const response = await axiosInstance.get(
        `${CALENDAR_API_URL}/birthdays/getByRange.php?idempresa=${idempresa}&start=${startTimestamp}&end=${endTimestamp}`
      );
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter aniversários:', error);
      return [];
    }
  },

  // Criar ou atualizar evento
  async setEvent(eventData) {
    try {
      const response = await axiosInstance.post(`${CALENDAR_API_URL}/set.php`, eventData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar evento:', error);
      throw error;
    }
  },

  // Apagar evento
  async unsetEvent(idempresa, idevent) {
    try {
      const response = await axiosInstance.get(
        `${CALENDAR_API_URL}/unset.php?idempresa=${idempresa}&idevent=${idevent}`
      );
      return response.data;
    } catch (error) {
      console.error('Erro ao apagar evento:', error);
      throw error;
    }
  }
};

export default calendarService;
